import { toKeyValue, isObject } from '../common';

var enumerableProperties = {};
for (let key in '') enumerableProperties[key] = true;

/* istanbul ignore file */
if (!String.prototype.capitalize) {
  String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
  };
}

if (!String.prototype.splitByUpperCase) {
  String.prototype.splitByUpperCase = function () {
    var ret = this.split(/(?=[A-Z])/);
    return ret;
  };
}

if (!String.prototype.camelCase) {
  String.prototype.camelCase = function () {
    var uperStart = (this.match(/^[A-Z]+/g) || ['']).first();
    return uperStart.toLowerCase() + this.substring(uperStart.length);
  };
}

if (!String.prototype.format) {
  String.prototype.format = function (...args) {
    var str = this.toString();
    if (args.length) {
      var keyVal = (args.length === 1 && isObject(args[0])) ? toKeyValue(args[0]) : args.map((f, ind) => ({ key: ind, value: f }));
      return keyVal.reduce((acc, f) => acc.replace(new RegExp(`\\{${f.key}\\}`, 'gi'), f.value), str);
    }
    return str;
  };
}

function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}
String.prototype.replaceAll = String.prototype.replaceAll ||
  function (fromString, toString) {
    return this.replace(new RegExp(escapeRegExp(fromString), 'g'), toString);
  };

var noEnumerableProperties = {};
for (let key in '') {
  if (!enumerableProperties[key]) noEnumerableProperties[key] = { enumerable: false };
}
Object.defineProperties(String.prototype, noEnumerableProperties);